/**
 * VendorRoute — wraps all /v4/vendor/* screens.
 *
 * Allows: user_role === 'vendor' | 'sub'
 * Blocks: contractors (null / 'contractor' / 'gc') → redirect to /dashboard
 * Loading: renders skeleton spinner while auth resolves
 */

import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth, isVendor } from '../../context/AuthContext'

interface VendorRouteProps {
  children: ReactNode
}

export default function VendorRoute({ children }: VendorRouteProps) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'var(--bg)',
      }}>
        <div className="auth-spinner" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/vendor/login" replace />
  }

  if (!isVendor(user)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
